import React, { useState, useRef, useEffect } from 'react';

const CopyButton = ({ text, label = 'Copy', copiedLabel = 'Copied!' }) => {
  const [copied, setCopied] = useState(false);
  const timerRef = useRef(null);

  const onCopy = async () => {
    if (!text) return;
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      }
      setCopied(true);
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => setCopied(false), 1500);
    } catch (_) { /* ignore */ }
  };

  useEffect(() => () => {
    if (timerRef.current) clearTimeout(timerRef.current);
  }, []);

  return (
    <button className={`copy-btn ${copied ? 'copied' : ''}`} onClick={onCopy} type="button">
      {copied ? '✓ ' + copiedLabel : '⧉ ' + label}
    </button>
  );
};

export default CopyButton;
